var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.layout == 'dashboard')?_c('DashboardLayout',[_c('router-view',{key:_vm.$route.fullPath})],1):(_vm.$route.meta.layout == 'topOnly')?_c('TopOnlyLayout',[_c('router-view')],1):_c('DefaultLayout',[_c('router-view')],1),_c('MariChatIntroModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }